export interface ColumnTypeInfo {
  type: 'number' | 'boolean' | 'array' | 'object' | 'string';
  isInteger?: boolean;
  arrayItemType?: string;
}

export const detectColumnType = (sampleValue: unknown): ColumnTypeInfo => {
  if (typeof sampleValue === 'number') {
    return { type: 'number', isInteger: Number.isInteger(sampleValue) };
  }

  if (typeof sampleValue === 'boolean') {
    return { type: 'boolean' };
  }

  if (Array.isArray(sampleValue)) {
    return {
      type: 'array',
      arrayItemType: sampleValue.length > 0 ? typeof sampleValue[0] : 'unknown',
    };
  }

  if (typeof sampleValue === 'object' && sampleValue !== null) {
    return { type: 'object' };
  }

  return { type: 'string' };
};
